import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async multiDelete(_, { deleteMap }) {
    const response = await axios.delete('/blade/multidelete', { data: { deleteMap } });
    return response.data;
  },
  async requestSafeDeepDelete(_, { collection, _id }) {
    const response = await axios.get(`/blade/requestsafedeepdelete/${collection}/${_id}`);
    // console.log(response.data);
    return response.data.deleteMap;
  },
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/deep-delete.js